// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

// Code generated by Microsoft (R) AutoRest Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is regenerated.

import type {
  SignatureOverridesFilterValuesQuery,
  FirewallPolicyIdpsSignaturesFilterValuesListOptionalParams,
  FirewallPolicyIdpsSignaturesFilterValuesListResponse,
} from "../models/index.js";

/** Interface representing a FirewallPolicyIdpsSignaturesFilterValues. */
export interface FirewallPolicyIdpsSignaturesFilterValues {
  /**
   * Retrieves the current filter values for the signatures overrides
   * @param resourceGroupName The name of the resource group.
   * @param firewallPolicyName The name of the Firewall Policy.
   * @param parameters Describes the filter values possibles for a given column
   * @param options The options parameters.
   */
  list(
    resourceGroupName: string,
    firewallPolicyName: string,
    parameters: SignatureOverridesFilterValuesQuery,
    options?: FirewallPolicyIdpsSignaturesFilterValuesListOptionalParams,
  ): Promise<FirewallPolicyIdpsSignaturesFilterValuesListResponse>;
}
